import {
  AddRemittanceDetailsProps,
  EditRemittanceDetailsProps,
  GetCurrencyType,
  GetRemittanceDetailsType,
} from '../../../../types/Invoicing/RemittanceDetails/remittanceDetailstype'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import { AllowedHttpMethods, remittanceDetailsApiConfig } from '../../apiList'

const getCurrencyList = async (
  currency: string,
): Promise<GetCurrencyType[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: remittanceDetailsApiConfig.getCurrency,
    method: AllowedHttpMethods.get,
    params: {
      currency,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getRemittanceList = async (): Promise<GetRemittanceDetailsType> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: remittanceDetailsApiConfig.getRemittanceList,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const deleteRemittanceList = async (
  remittanceid: number,
): Promise<GetCurrencyType[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: remittanceDetailsApiConfig.getRemittanceList,
    method: AllowedHttpMethods.delete,
    params: {
      remittanceid,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const addCurrency = async (type: string): Promise<GetRemittanceDetailsType> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: remittanceDetailsApiConfig.addCurrency,
    method: AllowedHttpMethods.post,
    data: {
      type,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const deleteCurrency = async (
  currencyId: number,
): Promise<GetCurrencyType[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: remittanceDetailsApiConfig.deleteCurrency,
    method: AllowedHttpMethods.delete,
    params: {
      currencyId,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const addRemittanceDetails = async (
  addRemittanceItems: AddRemittanceDetailsProps,
): Promise<number | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: remittanceDetailsApiConfig.addRemittanceDetails,
    method: AllowedHttpMethods.post,
    data: addRemittanceItems,
  })
  const responseVisa = await useAxios(requestConfig)
  return responseVisa.data
}
const editRemittanceDetails = async (
  editRemittanceItems: EditRemittanceDetailsProps,
): Promise<number | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: remittanceDetailsApiConfig.editRemittanceDetails,
    method: AllowedHttpMethods.put,
    data: editRemittanceItems,
  })
  const responseVisa = await useAxios(requestConfig)
  return responseVisa.data
}

const remittanceDetailsListApi = {
  getRemittanceList,
  deleteRemittanceList,
  getCurrencyList,
  addCurrency,
  deleteCurrency,
  addRemittanceDetails,
  editRemittanceDetails,
}

export default remittanceDetailsListApi
